.header {
  font-weight: 700 !important;
}

.sortableHeader {
  font-weight: 700 !important;
  color: var(--blue) !important;

  &:hover,
  &:focus {
    cursor: pointer;
    color: var(--blueActive);
  }
}
